import DesignTokens from '@tableau/design-tokens';
import { stylesheet } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

export const styles = stylesheet({
    agentSettingsTable: {
        width: 800,
        display: 'block',
        minWidth: 800,
        $nest: {
            'img[role=presentation]': {
                display: 'none',
            }
        }
    },
    cell: {
        display: 'table-cell',
        padding: '8px 24px',
        paddingRight: 24,
        height: 'auto',
        alignItems: 'center',
        verticalAlign: 'middle',
        borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#c9c9c9'),
   },
    cellWithIcon: {
        display: 'table-cell',
        padding: '8px 24px 8px 8px',
        height: 'auto',
        alignItems: 'center',
        verticalAlign: 'middle',
        borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#c9c9c9'),
        $nest: {
            span: {
                display: 'block',
                float: 'left',
            }
        },
   },
    header: {
            borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.medium, '#939393'),
            fontWeight: 'bold',
            height: 32,
    },
    row: {
        display: 'table-row',
        verticalAlign: 'center',
        width: 800,
        minWidth: 800,
        padding: '24px 0',
    },
    actionButton:{
        position: 'relative',
        top: 4,
    },
    bodyRow: {
        borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.surface.default.default, '#c9c9c9'),
    },
    tBody: {
        display: 'block'
    },
    table: {
        display: 'table'
    },
    agentNameCell: {
        width: 310,
        maxWidth: 310,
        minWidth: 310,
        paddingLeft: 24,
        paddingRight: 24,
        textOverflow: 'clip',
    },
    trialDisclaimer: {
        fontStyle: 'italic',
        display: 'inline',
    },
    nameSpan: {
        maxWidth: '100%',
        display: 'inline-block',
    },
    actions: {
        width: 50,
        maxWidth: 50,
        textAlign: 'left',
    },
    icon: {
        position: 'relative',
        paddingRight: 4,
        top: 3,
        display: 'block',
    },
    hasIcon: {
        display: 'flex',
        $nest: {
            span: {
                width: '90%',
            }
        },
        alignContent: 'center',
    },
    groupIcon: {
        left: 0,
    },
    status: {
        width: 140,
        maxWidth: 140,
        minWidth: 140
    },
    statusSpan: {
        maxWidth: '100%',
    },
    group: {
        width: 100,
        maxWidth: 100,
        minWidth: 100,
    },
    descriptionParagraph: {
        marginBottom: 0,
    },
    explainerHeader: {
        marginTop: 24,
    },
});
